export default __webpack_public_path__ + "static/media/fish.2dc68036.gif";